import { render } from "./AdminRol.vue?vue&type=template&id=f88bd28e&scoped=true"
import script from "./AdminRol.vue?vue&type=script&lang=js"
export * from "./AdminRol.vue?vue&type=script&lang=js"

import "./AdminRol.vue?vue&type=style&index=0&id=f88bd28e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88bd28e"]])

export default __exports__